import React from "react";
import { HiOutlineFlag } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneEmbassy } from "../../../lib/sysNavigation/SysNavigation";

type EmbassyRow = {
  embassy_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<EmbassyRow>
    type={_TYPES_.EMBASSY}
    title="Embassies"
    subtitle="Diplomatic offices listed on the public site."
    icon={<HiOutlineFlag className="h-5 w-5" />}
    addRoute="/data/embassy/add"
    editRoute="/data/embassy/edit"
    pushOne={pushOneEmbassy}
    dataKey="embassies"
    countKey="embassiesCount"
    idField="embassy_id"
  />
);

export default Overview;
